/* ACTUS 原廠沙發鍍膜 加購（2026-10-28）— 搭配 snippets/coating-upsell.liquid
   商品頁：下拉選了款式後，由 product-form.js 呼叫 getExtraItem() 連同沙發一起送出
   購物車：按「加入」→ /cart/add.js → 重繪抽屜／購物車頁（重繪邏輯沿用 pocket-gift.js） */
if (!customElements.get('coating-upsell')) {
  class CoatingUpsell extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-cu-select]');
      this.price = this.querySelector('[data-cu-price]');
      this.error = this.querySelector('.coating-upsell__error');
      this.addBtn = this.querySelector('[data-cu-add]');

      this.select?.addEventListener('change', () => {
        if (this.error) this.error.hidden = true;
        if (this.price) {
          const p = this.select.selectedOptions[0]?.dataset.price || '';
          this.price.textContent = p ? `+NT${p}` : '';
        }
      });
      this.addBtn?.addEventListener('click', () => this.addFromCart());
    }

    // 商品頁用：下拉停在「不加購鍍膜」回 null（沙發照原流程加入）；選了款式回要一起加入的鍍膜
    getExtraItem() {
      const id = this.select?.value;
      if (!id) return null;
      return { id, note: this.dataset.sofa || '' };
    }

    async addFromCart() {
      const id = this.select.value;
      if (!id) {
        this.error.textContent = '請先選擇沙發款式';
        this.error.hidden = false;
        return;
      }
      const sofa = this.dataset.sofa || '';
      this.addBtn.disabled = true;
      this.error.hidden = true;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: { '適用沙發': sofa } }] }),
        });
        if (!res.ok) {
          const j = await res.json().catch(() => ({}));
          throw new Error(j.description || j.message || '加入失敗，請再試一次');
        }
        await CoatingUpsell.refresh();
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'coating-upsell' });
      } catch (e) {
        this.error.textContent = e.message;
        this.error.hidden = false;
        this.addBtn.disabled = false;
      }
    }

    // 重繪購物車抽屜／購物車頁（與 pocket-gift.js 相同做法）
    static async refresh() {
      const root = window.Shopify?.routes?.root || '/';
      const drawer = document.querySelector('cart-drawer');
      const pageItems = document.getElementById('main-cart-items');
      const ids = ['cart-icon-bubble'];
      if (drawer) ids.push('cart-drawer');
      if (pageItems) ids.push(pageItems.dataset.id);
      const sections = await (await fetch(`${root}?sections=${ids.join(',')}`)).json();
      const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        const src = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
        if (src) bubble.innerHTML = src.innerHTML;
      }
      if (drawer && sections['cart-drawer']) {
        const src = parse(sections['cart-drawer']).querySelector('.drawer__inner');
        const dst = drawer.querySelector('.drawer__inner');
        if (src && dst) dst.innerHTML = src.innerHTML;
      }
      if (pageItems && sections[pageItems.dataset.id]) {
        const doc = parse(sections[pageItems.dataset.id]);
        [['#main-cart-items', '.js-contents'], ['#main-cart-footer', '.js-contents-2']].forEach(([box, sel]) => {
          const src = doc.querySelector(`${box} ${sel}`);
          const dst = document.querySelector(`${box} ${sel}`);
          if (src && dst) dst.innerHTML = src.innerHTML;
        });
      }
    }
  }
  customElements.define('coating-upsell', CoatingUpsell);
}
